import Api from '@/servicesLocal/Api'
const path = 'maincourse'

export default {
    index(name,description, page,limit,visible,spotlight) {
        return Api().get(path, {
            params: {
                name,
                description,
                page,
                limit,
                visible,
                spotlight
            }
        })
    },
    show(id) {
        return Api().get(path + `/${id}`)
    },
    addUpdate(type) {
        return Api().post(path, type)
    },
    delete(id) {
        return Api().delete(path + `/${id}`)
    }
}